/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";

function ListImage (props) {
    
    const image = props?.image;
    const width = 200;
    const alt = image?.alt;
    const title = image?.title;
    const url = image?.url;

    return (
        <Fragment>
            {image && (
                <div>
                    <img
                        alt={alt}
                        title={title}
                        width={width}
                        src={url}
                    />
                </div>
            )}
        </Fragment>
    );
}

export { ListImage };
